import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGroups = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_GROUPS_CASHIERS
            });

            if (data.status === 'success') {
                dispatch(Action.SetGroupsAction(data.groups));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGroups as SetGroups
}